import React from 'react';
import { useLocation } from 'react-router-dom';
import { MessageSquare, Users, Newspaper, Calendar, MessageCircle, Contact } from 'lucide-react';
import { ZijMenu, type ZijMenuGroep } from './ZijMenu';

interface CommunitySidebarProps {
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}

const GROUPS = [
  {
    label: 'Professionals',
    items: [
      { label: 'Smoelenboek van vakgenoten', href: '/community/professionals', icon: Contact },
    ],
  },
  {
    label: 'Chat professionals',
    items: [
      { label: 'Directe berichten en groepen', href: '/professionals/chat', icon: MessageCircle },
    ],
  },
  {
    label: 'Intervisiegroepen',
    items: [
      { label: 'Peer learning groepen', href: '/intervisie', icon: Users },
    ],
  },
  {
    label: 'Forum',
    items: [
      { label: 'Kennis en casussen uitwisselen', href: '/community', icon: MessageSquare, exact: true },
    ],
  },
  {
    label: 'Actualiteiten',
    items: [
      { label: 'Branche-artikelen delen', href: '/newsroom', icon: Newspaper },
    ],
  },
  {
    label: 'Meet & Connect',
    items: [
      { label: 'Koffiemomenten en borrels', href: '/connect-meet', icon: Calendar },
    ],
  },
];

export const CommunitySidebar: React.FC<CommunitySidebarProps> = ({ mobileOpen, onMobileClose }) => {
  const { pathname } = useLocation();
  const groepen: ZijMenuGroep[] = GROUPS.map((group) => ({
    label: group.label,
    items: group.items.map((item) => ({
      key: item.href,
      label: item.label,
      href: item.href,
      icon: item.icon,
      actief: 'exact' in item && item.exact ? pathname === item.href : pathname === item.href || pathname.startsWith(item.href + '/'),
    })),
  }));

  return (
    <ZijMenu
      titel="Community"
      ondertitel="Kennis delen, intervisie en ontmoeten"
      groepen={groepen}
      mobielOpen={mobileOpen}
      onMobielSluit={onMobileClose}
    />
  );
};
